import React from 'react';

export default function StatsBar({ stats }) {
  const cards = [
    { label: 'Total Orders', value: stats.total, color: '#3182ce', bg: 'rgba(49,130,206,0.08)' },
    { label: 'Assigned', value: stats.assigned, color: '#38a169', bg: 'rgba(56,161,105,0.08)' },
    { label: 'Unassigned', value: stats.unassigned, color: '#dd6b20', bg: 'rgba(221,107,32,0.08)' },
    { label: 'Rush', value: stats.rush, color: '#e53e3e', bg: 'rgba(229,62,62,0.08)' },
  ];

  return (
    <div className="stats-bar">
      {cards.map(card => (
        <div key={card.label} className="stat-card" style={{ borderColor: card.color, background: card.bg }}>
          <div className="stat-value" style={{ color: card.color }}>{card.value}</div>
          <div className="stat-label">{card.label}</div>
          <div className="stat-bar">
            <div
              className="stat-bar-fill"
              style={{
                width: `${stats.total ? (card.value / stats.total) * 100 : 0}%`,
                background: card.color
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
